(function () {
    'use strict';

    angular
        .module('app')
        .factory('PatternService', PatternService);

    function PatternService($http, $q, WebAPIUrl, WebApiService) {

        var service = {
            isPatternNameExists: isPatternNameExists,
            createPatternSeasonal: createPatternSeasonal,
            getPatternDetails: getPatternDetails,
            getPatternSeasonalDetails: getPatternSeasonalDetails,
            getPatternBriefs: getPatternBriefs,
            getPatternPrototypes: getPatternPrototypes,
            getPatternCriticalPaths: getPatternCriticalPaths,
            getPatternsByBrandSeason: getPatternsByBrandSeason,
            getDevelopmentTypeList: getDevelopmentTypeList,
            getAllDevelopmentTypeList: getAllDevelopmentTypeList,
            getFabricBottomOutsoleList: getFabricBottomOutsoleList,
            getProductLineList: getProductLineList,
            getSeasonalProgramList: getSeasonalProgramList,
            getOffsetList: getOffsetList,
            getAllDevelopersList: getAllDevelopersList,
            searchDevelopers: searchDevelopers,
            getMembraneSupplierList: getMembraneSupplierList,
            getMembranePackageList: getMembranePackageList,
            updatePattern: updatePattern,
            getSpecLogData: getSpecLogData,
            GetPatternByBrandNameGender: GetPatternByBrandNameGender,
            CanAdopt: CanAdopt,
            getOriginalFOBTarget: getOriginalFOBTarget,
            getOriginalAdoptedDate: getOriginalAdoptedDate,
            isDualSourced: isDualSourced,
            getGenders: getGenders,
            getLastNames: getLastNames,
            checkLastNames: checkLastNames,
            getCustomers: getCustomers,
            getConstructions: getConstructions,
            getPatternNames: getPatternNames,
            getCollections: getCollections,
            getHierarchyCodes: getHierarchyCodes,
            getActivityTypes: getActivityTypes,
            searchPatterns: searchPatterns,
            exportPatterns: exportPatterns,
            deletePatternSeasonal: deletePatternSeasonal,
            getPatternStatuses: getPatternStatuses,
            getOutsoles: getOutsoles,
            uploadMassPatternDocument: uploadMassPatternDocument,
            relinkPattern: relinkPattern,
            getBriefAndLinePlanForPattern: getBriefAndLinePlanForPattern,
            canPatternShiftSeason: canPatternShiftSeason,
            canPatternCarryover: canPatternCarryover,
            ensureReleased: ensureReleased,
            getDevelopmentCentersForPattern: getDevelopmentCentersForPattern,
            getAllDevelopmentCenters: getAllDevelopmentCenters,

            filterDevelopersByRole: function (allDevelopers, role, id, includeIfInactive) {
                return _.filter(allDevelopers, function (d) {
                    return d.DeveloperRoleId === role && (d.IsActive || (includeIfInactive && d.DeveloperId === id));
                });
            }
        };

        return service;

        function getBriefAndLinePlanForPattern(patternId, seasonId) {
            return WebApiService.get("/api/Pattern/GetBriefAndLinePlanForPattern?patternId=" + patternId + "&seasonId=" + seasonId);
        }

        function canPatternShiftSeason(patternId) {
            var deferred = $q.defer();

            WebApiService.get("/api/Pattern/CanPatternShiftSeason?patternId=" + patternId).then(
                function (result) {
                    deferred.resolve(result.Result === 0 && result.Data === true);
                },
                function () {
                    deferred.resolve(false);
                });

            return deferred.promise;
        }

        function canPatternCarryover(patternSeasonalId) {
            var deferred = $q.defer();

            WebApiService.get("/api/Pattern/CanPatternCarryover?patternSeasonalId=" + patternSeasonalId).then(
                function (result) {
                    deferred.resolve(result.Result === 0 && result.Data === true);
                },
                function () {
                    deferred.resolve(false);
                });

            return deferred.promise;
        }

        function getOutsoles() {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/GetOutsoles',
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function isPatternNameExists(patternId, patternName, brandId, seasonId) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/IsPatternNameExists?PatternId=' + patternId + '&PatternName=' + patternName + '&BrandId=' + brandId + '&SeasonId=' + seasonId,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                //alert('error');
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function createPatternSeasonal(patternData, patternSeasonalData, briefId, ignoreLoadingBar) {
            var data = { pattern: patternData, patternSeasonal: patternSeasonalData, briefId: briefId };
            return WebApiService.postJson("/api/Pattern/CreatePatternSeasonal", data, "", ignoreLoadingBar === true);
        }

        function getPatternDetails(patternId) {
            return WebApiService.get("/api/Pattern/PatternDetails?PatternId=" + patternId);
        }

        function getPatternSeasonalDetails(patternSeasonalId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/PatternSeasonalDetails?PatternSeasonalId=' + patternSeasonalId,
                data: patternSeasonalId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                if (status == 404) {
                    deferred.resolve(null);
                } else {
                    alert(err);
                    deferred.reject(err, status);
                }
            });

            return deferred.promise;

        }

        function getPatternBriefs(patternSeasonalId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/PatternBriefs?PatternSeasonalId=' + patternSeasonalId,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getPatternPrototypes(patternSeasonalId, ignoreLoadingBar) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/PatternPrototypes?PatternSeasonalId=' + patternSeasonalId,
                ignoreLoadingBar: ignoreLoadingBar ? ignoreLoadingBar : false
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getPatternCriticalPaths(patternSeasonalId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/PatternCriticalPaths?PatternSeasonalId=' + patternSeasonalId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getPatternsByBrandSeason(brandId, seasonId, patternId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/PatternsByBrandSeason?BrandId=' + brandId + '&SeasonId=' + seasonId + '&PatternId=' + patternId,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                //alert('error');
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getAllDevelopmentTypeList() {
            return WebApiService.get('/api/Pattern/AllDevelopmentTypeList');
        }


        function getDevelopmentTypeList(isNew) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/DevelopmentTypeList?IsNew=' + isNew,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getFabricBottomOutsoleList() {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/FabricBottomOutsoleList',
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getSeasonalProgramList() {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/SeasonalProgramList',
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getProductLineList() {
            return WebApiService.get('/api/Pattern/ProductLineList');
        }

        function getOffsetList() {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/OffsetList',
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getAllDevelopersList(brandId, includeInactive) {
            return WebApiService.get("/api/Pattern/AllDevelopersList?BrandId=" + brandId + "&includeInactive=" + includeInactive);
        }

        function searchDevelopers(searchText, brandId, roleId) {
            return WebApiService.get("/api/Pattern/SearchDevelopers?searchText=" + searchText + "&brandId=" + brandId + "&roleId=" + roleId);
        }

        function getMembraneSupplierList() {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/MembraneSupplierList',
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getMembranePackageList() {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/MembranePackageList',
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function updatePattern(patternData, patternSeasonalData, specLogData, updatePrototypeSampleWeightData, devCenters) {
            return WebApiService.postJson("/api/Pattern/UpdatePattern", { pattern: patternData, patternSeasonal: patternSeasonalData, specLog: specLogData, updatePrototypeSampleWeight: updatePrototypeSampleWeightData, devCenters: devCenters }, undefined, false);
        }

        function getSpecLogData(projectId, projectLevelId, seasonId, patternNameKey, isSameSeason) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/SpecLogData?ProjectId=' + projectId + '&ProjectLevelId=' + projectLevelId + '&SeasonId=' + seasonId + '&PatternNameKey=' + patternNameKey + '&isSameSeason=' + isSameSeason,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function GetPatternByBrandNameGender(patternNameKey, genderKey, brandId, ignoreThisPatternId) {
            return WebApiService.get("/api/Pattern/GetPatternByBrandNameGender?patternNameKey=" + patternNameKey + "&genderKey=" + genderKey + "&brandId=" + brandId + "&ignoreThisPatternId=" + ignoreThisPatternId);
        }

        function CanAdopt(patternId, seasonId) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/CanAdopt?PatternId=' + patternId + '&SeasonId=' + seasonId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getOriginalFOBTarget(patternSeasonalId) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/GetOriginalFOBTarget?PatternSeasonalId=' + patternSeasonalId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getOriginalAdoptedDate(patternId, seasonId, patternNameKey, genderKey) {

            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/GetOriginalAdoptedDate?PatternId=' + patternId + '&SeasonId=' + seasonId + '&PatternNameKey=' + patternNameKey + '&GenderKey=' + genderKey,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function isDualSourced(patternSeasonalId) {
            return WebApiService.get('/api/Pattern/IsDualSourced?patternSeasonalId=' + patternSeasonalId);
        }

        function getGenders(searchText, maxResults) {
            return WebApiService.get("/api/Pattern/GetGenders?searchText=" + (searchText ? searchText : "") + "&maxResults=" + (maxResults !== undefined ? maxResults : 10));
        }

        function getLastNames(brandId, searchText) {
            return WebApiService.get("/api/Pattern/GetLastNames?searchText=" + (searchText ? searchText : "") + "&brandId=" + (brandId !== undefined ? brandId : 0));
        }

        function checkLastNames(searchText) {
            return WebApiService.get("/api/Pattern/CheckLastNames?searchText=" + searchText);
        }

        function getCustomers(searchText) {
            return WebApiService.get("/api/Pattern/GetCustomers?searchText=" + (searchText ? searchText : ""));
        }

        function getConstructions() {
            return WebApiService.get('/api/Pattern/GetConstructions');
        }

        function getPatternNames() {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Pattern/GetPatternNames',
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getHierarchyCodes(searchText) {
            return WebApiService.get("/api/Pattern/GetHierarchyCodes?searchText=" + (searchText ? searchText : ""));
        }

        function getCollections(brandId, searchText) {
            return WebApiService.get("/api/Pattern/GetCollections?brandId=" + (brandId ? brandId : "") + " &searchText=" + (searchText ? searchText : ""));
        }

        function getActivityTypes(searchText) {
            return WebApiService.get("/api/Pattern/GetActivityTypes?searchText=" + (searchText ? searchText : ""));
        }

        function searchPatterns(searchObject, pageNumber, pageSize, sortColumn, sortDirection) {

            var deferred = $q.defer();

            searchObject.pageNumber = pageNumber;
            searchObject.pageSize = pageSize;
            searchObject.sortColumn = sortColumn;
            searchObject.sortDirection = sortDirection;

            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Pattern/SearchPatterns",
                headers: { 'Content-Type': 'application/json' },
                data: JSON.stringify(searchObject),
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function exportPatterns(searchObject, pageNumber, pageSize, sortColumn, sortDirection) {
            searchObject.pageNumber = pageNumber;
            searchObject.pageSize = pageSize;
            searchObject.sortColumn = sortColumn;
            searchObject.sortDirection = sortDirection;

            return WebApiService.postJson("/api/Pattern/ExportPatterns", searchObject);
        }

        function deletePatternSeasonal(patternSeasonalId) {

            var deferred = $q.defer();

            $http({
                method: 'POST',
                url: WebAPIUrl + '/api/Pattern/DeletePatternSeasonal?PatternSeasonalId=' + patternSeasonalId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getPatternStatuses(brandId, seasonId, filterUser, ignoreLoader) {
            return WebApiService.get("/api/Pattern/GetPatternStatuses?BrandId=" + brandId + '&SeasonId=' + seasonId + '&filterUser=' + filterUser, '', '', ignoreLoader);
        }


        function uploadMassPatternDocument(file) {
            return WebApiService.postFile("/api/Pattern/UploadPatterns", file);
        }

        function relinkPattern(patternId, newBriefId, oldBriefId) {

            var jsonBody = {
                patternId: patternId,
                newBriefId: newBriefId,
                oldBriefId: oldBriefId
            };

            const config = {
                ignoreLoadingBar: true
            };

            return WebApiService.postJson('/api/Pattern/RelinkPattern', jsonBody, config);
        }

        function ensureReleased(patternSeasonalId) {
            return WebApiService.postJson('/api/Pattern/EnsureReleased?patternSeasonalId=' + patternSeasonalId);
        }

        function getDevelopmentCentersForPattern(patternId) {
            return WebApiService.get("/api/Pattern/GetDevelopmentCentersForPattern?patternId=" + patternId);
        }

        function getAllDevelopmentCenters(patternId) {
            return WebApiService.get("/api/Pattern/GetAllDevelopmentCenters");
        }
    }

})();
